"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * E.g. Convert "camelCaseToKebabCase" to "camel-case-to-kebab-case"
 * Kebab case most popular in urls
 *
 * @param text
 */
exports.default = (text) => {
    const addSpaces = text.replace(/([A-Z])/g, ' $1').toLowerCase();
    return addSpaces.split(' ').join('-');
};
